import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const HalfPriceRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 14 14'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill='#08033B'>
      <path d='M1.9 2.7H.5c-.3 0-.5-.1-.5-.5s.2-.5.8-.6l.4-.1C2.4 1.2 2 0 2.9 0c.3 0 .6.2.6.7v6.1c0 .6-.2.9-.8.9-.6 0-.8-.4-.8-.9V2.7zM8.3 2.7c.1-.2.3-.5.9-.4.3.1.6.4.6.8 0 .1-.1.3-.2.4l-5.1 7.8c-.1.2-.3.5-.9.4-.3-.1-.6-.4-.6-.8 0-.1.1-.3.2-.4l5.1-7.8zM13.3 12.6c.4 0 .7.2.7.7 0 .5-.3.7-.8.7h-4c-.6 0-.9-.4-.9-.8 0-.8.7-1.6 2-2.5 1.5-.9 2-1.1 2-2 0-.7-.5-1.1-1.1-1.1-.7 0-1.1.3-1.4 1.1-.1.5-.2.7-.7.7-.4 0-.8-.2-.8-.7 0-1.3 1.3-2.3 2.9-2.3 1.7 0 2.7 1.1 2.7 2.1 0 1.4-.7 2-1.8 2.6-1.2.7-2 1.1-2.1 1.5h3.3z' />
    </g>
  </svg>
)

export { HalfPriceRegular }
